import React, { FC, FocusEventHandler, ReactNode, useState } from 'react'
import { Grid } from '@mui/material';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import { PickerValue } from '@mui/x-date-pickers/internals';

export interface InputDateProperties {
    id?: string;
    name?: string;
    className?: string;
    label: string;
    format?: string;
    value?: any;
    defaultValue?: string;
    pattern?: string;
    size?: "small" | "medium";
    fullWidth: boolean;
    error?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    margin?: "normal" | "dense" | "none";
    type?: "date" | "datetime-local";
    InputProps?: any;
    inputProps?: any;
    maxDate?: Date | string;
    minDate?: Date | string;
    prefix?: ReactNode;
    onKeyPress?: Function;
    onKeyUp?: Function;
    onKeyDown?: Function;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onFocus?: Function;
    onChange?: (date: string | null) => void,
    helperText?: string
    placeholder?: string
}


const InputDateMui: FC<InputDateProperties> = ({
    name,
    className,
    id = "input-date",
    label,
    value,
    defaultValue,
    size = "small",
    fullWidth = true,
    error = false,
    readonly = false,
    disabled = false,
    maxDate,
    minDate,
    margin = "normal",
    prefix,
    onBlur,
    onChange,
    helperText,
    placeholder,
}) => {
    const [errorState, setErrorState] = useState<boolean>(false);

    const handleDateChange = (value: PickerValue | Date | Dayjs) => {
        if (!onChange) return;

        if (value === null || (dayjs.isDayjs(value) && !value?.isValid())) {
            onChange(null);
        return;
        }

        const newDate = new Date(value?.toISOString());
        if (newDate instanceof Date && !isNaN(newDate.getTime())) {
            onChange(value?.toISOString());
        }
    };

    return <>
        <LocalizationProvider 
            dateAdapter={AdapterDayjs} 
            adapterLocale="pt-br"
            localeText={{ 
                fieldYearPlaceholder: () => "AAAA",

                cancelButtonLabel: 'Cancelar',
                okButtonLabel: 'Confirmar',
                nextStepButtonLabel: 'Próximo',
            }}
        >
            <Grid container justifyContent="space-around">
                <DatePicker
                    name={name}
                    label={label}
                    value={value ? dayjs(value) : null}
                    minDate={minDate ? dayjs(minDate) : undefined}
                    maxDate={maxDate ? dayjs(maxDate) : undefined}
                    defaultValue={defaultValue || value || moment()}
                    views={['year', 'month', 'day']}
                    disabled={disabled}
                    readOnly={readonly}
                    onChange={handleDateChange}
                    onError={(error) => {
                        setErrorState(!!error);
                    }}
                    slotProps={{
                        textField: {
                            id,
                            className,
                            fullWidth,
                            size,
                            margin,
                            helperText,
                            placeholder,
                            error: error || errorState,
                            InputLabelProps: {
                                shrink: true,
                            },
                            InputProps: {
                                startAdornment: prefix,
                            },
                            onBlur,
                        },
                        openPickerButton: {
                            size: 'small',
                        },
                    }}
                />
            </Grid>
        </LocalizationProvider>
    </>
}

export { InputDateMui }